import { init as initFavoriteBusHandler } from './favorite-bus-handler';
import { init as initProposalBusHandler } from './proposal-bus-handler';

export const initSelectionBusHandler = () => {
  initFavoriteBusHandler();
  initProposalBusHandler();
};
